import {
  PartialQuestionnaire,
  QuestionnaireConfiguration,
  QuestionnaireQuestions,
  Rule,
} from '../../models';
import { getRuleResult } from '../../rules';
import { createLogger } from '../../utils/logger';

/**
 *
 * QNR-Framework helper functionality to find the correct flow questions ids.
 * Depending on whether a question is required or not and if it
 * has dependents - this helper functionality will return all required question ids.
 *
 */
export const findPath = <
  Questionnaire extends QuestionnaireQuestions,
  GroupId,
  ExtendedComponentTypes
>(
  questionnaire: PartialQuestionnaire<
    Questionnaire,
    GroupId,
    ExtendedComponentTypes
  >,
  answers: Partial<Questionnaire>,
  rules: Rule<Questionnaire>[],
  configuration: QuestionnaireConfiguration<
    Questionnaire,
    ExtendedComponentTypes
  > = {}
): (keyof Questionnaire)[] => {
  const log = createLogger(configuration.debug ?? false);

  let path: (keyof Questionnaire)[] = [];
  for (const question of questionnaire) {
    if (question.required === true) {
      path.push(question.id);
    }
    // Check if the dependent question is required
    // The calculation is based on the the previous question
    // which calculates if the dependent path is required or not
    if (!path.includes(question.id)) {
      continue;
    }
    const questionRules = rules.filter((rule) => rule.id === question.id);
    if (questionRules.length === 0) {
      continue;
    }
    for (const rule of questionRules) {
      log('-------------------Rule-------------------', 'green');
      log(`QuestionId: ${String(question.id)}`);
      const result = getRuleResult(rule.if, answers, question.id, log);
      log(`Result: ${result}`, 'blue');
      if (result === true) {
        path.push(rule.then.goTo);
      } else if (rule.else) {
        path.push(rule.else.goTo);
      }
    }
  }

  return path;
};
